import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { translations } from '../utils/translations';

const Navigation = ({ language, setLanguage }) => {
  const t = translations[language];
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const location = useLocation();

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'it', name: 'Italiano' },
    { code: 'es', name: 'Español' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLanguageChange = (code) => {
    setLanguage(code);
    setIsLanguageMenuOpen(false);
  };

  const isHomePage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about';
  const isContactPage = location.pathname === '/contact';
  const isPrivacyPage = location.pathname === '/privacy';
  const isTermsPage = location.pathname === '/terms';
  const shouldBeTransparent = (isHomePage || isAboutPage || isContactPage || isPrivacyPage || isTermsPage) && !isScrolled;

  return (
    <nav className={`main-navigation ${isScrolled ? 'scrolled' : ''} ${shouldBeTransparent ? 'transparent' : ''}`}>
      <div className="nav-container">
        {/* Logo */}
        <Link to="/" className="nav-logo">
          <img 
            src="/logo.png" 
            alt="Atelier - The art of living in Ibiza"
            className="logo-image"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-links">
          <Link 
            to="/" 
            className={location.pathname === '/' ? 'active' : ''}
          >
            {t.nav.home}
          </Link>
          <Link 
            to="/about" 
            className={location.pathname === '/about' ? 'active' : ''}
          >
            {t.nav.about}
          </Link>
          <Link 
            to="/contact" 
            className={location.pathname === '/contact' ? 'active' : ''}
          >
            {t.nav.contact}
          </Link>
        </div>

        {/* Language Selector */}
        <div className="language-selector">
          <button 
            className="language-button"
            onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
          >
            <Globe size={18} strokeWidth={1.5} />
            <span>{languages.find(l => l.code === language)?.code.toUpperCase()}</span>
          </button>
          
          {isLanguageMenuOpen && (
            <div className="language-dropdown">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  className={language === lang.code ? 'active' : ''}
                >
                  {lang.name}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <Link 
            to="/" 
            onClick={() => setIsMobileMenuOpen(false)}
            className={location.pathname === '/' ? 'active' : ''}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            onClick={() => setIsMobileMenuOpen(false)}
            className={location.pathname === '/about' ? 'active' : ''}
          >
            About
          </Link>
          <Link 
            to="/contact" 
            onClick={() => setIsMobileMenuOpen(false)}
            className={location.pathname === '/contact' ? 'active' : ''}
          >
            Contact
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
